module.exports = __webpack_public_path__ + "static/media/WILD_OAT.34fbef23.JPG";